/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{useMemo as r}from"react";import{getOwnerDocument as e}from"../utils/owner.js";function t(...t){return r((()=>e(...t)),[...t])}export{t as useOwnerDocument};
//# sourceMappingURL=use-owner.js.map
